import {Component, OnInit} from '@angular/core';
import {API, MediumFullDTO, TemplateSourceDTO, TemplateSourceEntryDTO} from '../../../services/api/api';
import {ModalNavigationService} from '../../../services/gui/modal/modal-navigation.service';
import {ErrorService} from '../../../services/error.service';
import {ModalService} from '../../../services/gui/modal/modal.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'medium-template-preview',
  templateUrl: './medium-template-preview.component.html',
  styleUrls: ['./medium-template-preview.component.scss'],
  standalone: false,
})
export class MediumTemplatePreviewComponent implements OnInit {
  constructor(
    private api: API,
    private modal: ModalNavigationService,
    private errorHandler: ErrorService,
    private modalService: ModalService,
    private sanitizer: DomSanitizer
  ) {}

  template: string;
  html: SafeHtml;
  medium: MediumFullDTO;
  isInModalContext: boolean;
  entries: TemplateSourceEntryDTO[];
  source: TemplateSourceDTO;

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.medium = this.modal.getCurrentNavigation()?.data?.selectedMedium;
      this.source = this.modal.getCurrentNavigation()?.data?.templateSource;
      if (this.source && this.medium) {
        this.api.mm_templating_provider_TemplateSourceEntry_retrieveAllInSource(this.source.id).subscribe({
          next: (entries: TemplateSourceEntryDTO[]) => {
            this.entries = entries;
            this.getTemplateData(entries[0]);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
      }
    }
  }

  selectEntry(entry: TemplateSourceEntryDTO) {
    this.getTemplateData(entry);
  }

  getTemplateData(entry?: TemplateSourceEntryDTO) {
    this.api.mm_templating_provider_TemplateSourceEntry_render(this.source.id, entry ? entry.id : 0, this.medium.id).subscribe({
      next: (data: string) => {
        this.template = data;
        // tslint:disable-next-line:max-line-length
        const iframe =
          '<iframe style="-webkit-transform:scale(0.5); -moz-transform-origin: top left; -webkit-transform-origin: top left; -o-transform-origin: top left; -ms-transform-origin: top left; transform-origin: top left;" width="1920" height="1080" src="data:text/html;charset=utf-8,' +
          encodeURIComponent(this.template) +
          '" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
        this.html = this.sanitizer.bypassSecurityTrustHtml(iframe);
      },
      error: error => {
        this.errorHandler.errorHandler(error);
      },
    });
  }
}
